module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("Copyright © 1996 by Jack Womack")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced"), _c('br'), _vm._v("in any form or by any electronic or mechanical means, including"), _c('br'), _vm._v("information storage and retrieval systems, without permission in"), _c('br'), _vm._v("writing from the publisher, except by a reviewer, who may quote"), _c('br'), _vm._v("brief passages in a review.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("The Library of Congress has cataloged the hardcover edition as follows:"), _c('br'), _vm._v("Womack, Jack."), _c('br'), _vm._v("     Let’s put the future behind us / Jack Womack. — 1st ed."), _c('br'), _vm._v("         p. cm."), _c('br'), _vm._v("    1. Businessmen—Russia (Federation)—Moscow—Fiction. I. Title."), _c('br'), _vm._v("   PS3573.0575L48      1996"), _c('br'), _vm._v("   813′.54—dc.20                                                  95-43552"), _c('br'), _vm._v("     eBook ISBN-13: 978-1-5558-4760-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0